<template>
    <v-container class="pa-5" fluid>
        <ConfirmDialog
            :is-open="confirmRemoveLocalizationScreenDialog"
            :data="currentOutdoorsLocalizationScreen"
            @on-confirm="removeLocalizationScreen"
            @on-abort="closeConfirmRemoveLocalizationScreenDialog"
        >
            <template #title>
                Usuwanie ekranu
            </template>
            <template #content>
                Czy na pewno chcesz usunąć ekran?
            </template>
            <template #confirmButton>
                Usuń
            </template>
        </ConfirmDialog>

        <OutdoorsLocalizationScreenDialog
            :is-open="outdoorsLocalizationScreenDialog"
            :outdoors-localization-screen-data="currentOutdoorsLocalizationScreen"
            :outdoors-localization-data="localization"
            :customer-data="localization.customer"
            @on-confirm="saveLocalizationScreen"
            @on-close="closeOutdoorsLocalizationScreenDialog"
        />

        <MapDialog
            :is-open="mapDialog"
            :localization-data="localization"
            :google="google"
            :height="windowHeight"
            @on-save="saveCoordinates"
            @on-close="closeMapDialog"
        />

        <page-title>
            {{ pageTitle }}
        </page-title>
        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" xl="8" offset-xl="2">
                <v-container class="pa-0">
                    <v-row>
                        <v-col cols="12" lg="7" class="d-flex">
                            <v-container class="pa-0">
                                <v-row>
                                    <v-col cols="12">
                                        <v-card>
                                            <v-toolbar flat dense color="white lighten-2">
                                                <v-toolbar-title>Dane lokalizacji</v-toolbar-title>
                                            </v-toolbar>
                                            <v-divider />
                                            <v-card-text>
                                                <v-container>
                                                    <v-row>
                                                        <v-col cols="12" sm="6">
                                                            <v-text-field
                                                                :value="localization.name"
                                                                label="Nazwa"
                                                                outlined
                                                                dense
                                                                @input="changeLocalizationName"
                                                            />
                                                        </v-col>
                                                        <v-col cols="12" sm="6">
                                                            <v-text-field
                                                                v-model="localization.number"
                                                                label="Numer"
                                                                outlined
                                                                dense
                                                                :error-messages="numberErrors"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="12" sm="6">
                                                            <v-autocomplete
                                                                v-model="localization.customer"
                                                                :items="customers"
                                                                :filter="customFilter"
                                                                :loading="customersSearchLoading"
                                                                :search-input.sync="customersSearch"
                                                                class="v-text-field--placeholder-dark"
                                                                :error-messages="customerIdErrors"
                                                                label="Klient"
                                                                return-object
                                                                dense
                                                                outlined
                                                                item-value="id"
                                                                no-data-text="Nie znaleziono"
                                                            >
                                                                <template slot="no-data">
                                                                    <v-list-item>
                                                                        <v-list-item-title>
                                                                            <template v-if="!customersSearch">
                                                                                Wpisz treść aby odnaleźć <strong>klienta</strong>.
                                                                            </template>
                                                                            <template v-else-if="customersSearchLoading">
                                                                                Trwa wyszukiwanie...
                                                                            </template>
                                                                            <template v-else>
                                                                                Nie znaleziono
                                                                            </template>
                                                                        </v-list-item-title>
                                                                    </v-list-item>
                                                                </template>
                                                                <template slot="selection" slot-scope="data">
                                                                    {{ data.item.name }}
                                                                </template>

                                                                <template slot="item" slot-scope="data">
                                                                    {{ data.item.name }}
                                                                </template>
                                                            </v-autocomplete>
                                                        </v-col>
                                                        <v-col cols="12" sm="6">
                                                            <v-text-field
                                                                v-model="localization.street"
                                                                label="Ulica"
                                                                outlined
                                                                dense
                                                                :error-messages="streetErrors"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="12" sm="6">
                                                            <v-text-field
                                                                v-model="localization.postCode"
                                                                label="Kod pocztowy"
                                                                outlined
                                                                dense
                                                                :error-messages="postCodeErrors"
                                                            />
                                                        </v-col>
                                                        <v-col cols="12" sm="6">
                                                            <v-text-field
                                                                v-model="localization.city"
                                                                label="Miasto"
                                                                outlined
                                                                dense
                                                                :error-messages="cityErrors"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="12" sm="6">
                                                            <v-text-field
                                                                v-mask="'##.######'"
                                                                :value="localization.latitude"
                                                                label="Szerokość geograficzna"
                                                                outlined
                                                                dense
                                                                @input="changeLocalizationLatitude"
                                                                @change="saveCoordinates(localization.latitude, localization.longitude)"
                                                            />
                                                        </v-col>
                                                        <v-col cols="12" sm="6">
                                                            <v-text-field
                                                                v-mask="'##.######'"
                                                                :value="localization.longitude"
                                                                label="Długość geograficzna"
                                                                outlined
                                                                dense
                                                                @input="changeLocalizationLongitude"
                                                                @change="saveCoordinates(localization.latitude, localization.longitude)"
                                                            />
                                                        </v-col>
                                                    </v-row>

                                                    <v-row>
                                                        <v-col cols="12">
                                                            <v-autocomplete
                                                                v-model="localization.outdoorLocalizationTeamIds"
                                                                :items="outdoorLocalizationTeams"
                                                                :filter="customFilter"
                                                                :loading="outdoorLocalizationTeamsSearchLoading"
                                                                :search-input.sync="outdoorLocalizationTeamsSearch"
                                                                class="v-text-field--placeholder-dark"
                                                                label="Ekipy"
                                                                multiple
                                                                chips
                                                                dense
                                                                outlined
                                                                deletable-chips
                                                                cache-items
                                                                item-value="id"
                                                                no-data-text="Nie znaleziono"
                                                                @change="clearOutdoorLocalizationTeamsSearch()"
                                                            >
                                                                <template slot="no-data">
                                                                    <v-list-item>
                                                                        <v-list-item-title>
                                                                            <template v-if="!outdoorLocalizationTeamsSearch">
                                                                                Wpisz treść aby odnaleźć <strong>ekipę</strong>.
                                                                            </template>
                                                                            <template v-else-if="outdoorLocalizationTeamsSearchLoading">
                                                                                Trwa wyszukiwanie...
                                                                            </template>
                                                                            <template v-else>
                                                                                Nie znaleziono
                                                                            </template>
                                                                        </v-list-item-title>
                                                                    </v-list-item>
                                                                </template>
                                                                <template slot="selection" slot-scope="data">
                                                                    <v-chip
                                                                        small
                                                                        close
                                                                        @update:active="removeOutdoorLocalizationTeam(data.item)"
                                                                    >
                                                                        {{ data.item.name }}
                                                                    </v-chip>
                                                                </template>

                                                                <template slot="item" slot-scope="data">
                                                                    {{ data.item.name }}
                                                                </template>
                                                            </v-autocomplete>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>
                        <v-col cols="12" lg="5" class="d-flex">
                            <v-container class="d-flex pa-0">
                                <v-row>
                                    <v-col cols="12" class="d-flex">
                                        <v-card ref="mapPreview" min-height="450" class="flex-grow-1">
                                            <v-toolbar flat dense color="white lighten-2">
                                                <v-toolbar-title>Podgląd lokalizacji</v-toolbar-title>
                                                <v-spacer />
                                                <v-btn
                                                    color="primary"
                                                    outlined
                                                    data-sentry-label="Wskaż"
                                                    @click="showMapDialog"
                                                >
                                                    <v-icon left dark>
                                                        mdi-map-marker
                                                    </v-icon>
                                                    Wskaż
                                                </v-btn>
                                            </v-toolbar>

                                            <v-divider />

                                            <MapPreview
                                                :api-key="apiKey"
                                                :latitude="savedLatitude"
                                                :longitude="savedLongitude"
                                            />
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>
                    </v-row>
                    <v-row align="center">
                        <v-col cols="auto">
                            <h2 class="text-h6">
                                Ekrany
                            </h2>
                        </v-col>
                        <v-col cols="auto">
                            <v-tooltip :disabled="isCustomerSelected" :open-delay="tooltipDelay" top>
                                <template #activator="{on}">
                                    <div v-on="on">
                                        <v-btn
                                            color="secondary"
                                            fab
                                            small
                                            class="elevation-1"
                                            data-sentry-label="Dodaj ekran"
                                            :disabled="actionLoading || !isCustomerSelected"
                                            @click="showCreateOutdoorsLocalizationScreenDialog()"
                                        >
                                            <v-icon>
                                                mdi-plus
                                            </v-icon>
                                        </v-btn>
                                    </div>
                                </template>
                                <span>Aby dodać ekran wybierz klienta</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-card>
                                <v-card-text v-if="hasScreens">
                                    <v-data-table
                                        :headers="headers"
                                        :items="localization.outdoorLocalizationScreens"
                                        disable-pagination
                                        hide-default-footer
                                        :mobile-breakpoint="0"
                                        item-key="index"
                                    >
                                        <template #item.ordinalNumber="{item}">
                                            {{ item.ordinalNumber }}
                                        </template>
                                        <template #item.localizationScreenGroup="{item}">
                                            {{ item.localizationScreenGroup.name }}
                                        </template>
                                        <template #item.localizationScreenSize="{item}">
                                            {{ item.localizationScreenSize.sizeA }} x {{ item.localizationScreenSize.sizeB }}
                                        </template>
                                        <template #item.actions="{item}">
                                            <div class="d-inline-flex">
                                                <v-tooltip :open-delay="tooltipDelay" top>
                                                    <template #activator="{on}">
                                                        <v-btn
                                                            icon
                                                            data-sentry-label="Otwórz"
                                                            :disabled="!isCustomerSelected"
                                                            v-on="on"
                                                            @click="showEditLocalizationScreenDialog(item.index)"
                                                        >
                                                            <v-icon color="teal">
                                                                mdi-pencil
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Otwórz</span>
                                                </v-tooltip>
                                                <v-tooltip :open-delay="tooltipDelay" top>
                                                    <template #activator="{on}">
                                                        <v-btn
                                                            icon
                                                            data-sentry-label="Usuń"
                                                            v-on="on"
                                                            @click="showConfirmRemoveLocalizationScreenDialog(item.index)"
                                                        >
                                                            <v-icon color="pink">
                                                                mdi-delete
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Usuń</span>
                                                </v-tooltip>
                                            </div>
                                        </template>
                                    </v-data-table>
                                </v-card-text>

                                <v-card-text v-else>
                                    <v-alert
                                        type="info"
                                        text
                                        border="left"
                                        class="ma-0"
                                    >
                                        Brak ekranów dla lokalizacji.
                                    </v-alert>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-btn
                                color="success"
                                medium
                                data-sentry-label="Zapisz"
                                :loading="actionLoading"
                                @click="saveLocalization"
                            >
                                Zapisz
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { googleMapsApiLoader } from '@/utils/googleMapsApiLoader'
import store from '@/./store'

import { required, maxLength } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
import { isEmpty } from 'lodash'

import OutdoorsLocalizationScreenDialog from './OutdoorsLocalizationScreenDialog'
import MapDialog from '@/views/Outdoors/Common/MapDialog'
import MapPreview from '@/views/Outdoors/Common/MapPreview'
import ConfirmDialog from '@/components/common/ConfirmDialog'
import PageTitle from '@/components/common/PageTitle'

import { errorHandler, addSentryBreadcrumb } from '@/utils/errorHandler'

import customFilters from '@/mixins/customFilters'
import tooltipDelay from '@/mixins/tooltip'
import parse from '@/mixins/parse'

import { appConfig } from '@/config'

let searchTimer

export default {
    name: 'OutdoorsLocalization',
    directives: { mask },
    components: {
        PageTitle,
        OutdoorsLocalizationScreenDialog,
        MapDialog,
        ConfirmDialog,
        MapPreview
    },
    mixins: [ customFilters, tooltipDelay, parse ],
    beforeRouteEnter(to, from, next) {
        if (typeof to.params.id !== 'undefined') {
            store.dispatch('outdoors/outdoorsSettings/getLocalization', to.params.id)
                .then(response => {
                    Promise.all([
                        store.dispatch('outdoors/outdoorsSettings/getLocalizationScreenSizes'),
                    ])
                        .then(() => {
                            next(vm => {
                                vm.action = 'updateLocalization'
                                response.data.name ? vm.pageTitle = `Lokalizacja - ${response.data.name}` : vm.pageTitle = 'Lokalizacja'
                                vm.localization = Object.assign({}, response.data)
                                vm.savedLatitude = response.data.latitude
                                vm.savedLongitude = response.data.longitude

                                if (response.data.customer) {
                                    vm.customers.push(response.data.customer)
                                }

                                if (response.data.outdoorLocalizationTeams.length > 0) {
                                    vm.outdoorLocalizationTeams = response.data.outdoorLocalizationTeams
                                }

                                vm.indexedLocalizationScreens()
                            })
                        })
                        .catch(error => {
                            next(error)
                            errorHandler(error)
                        })
                })
                .catch(error => {
                    next(error)
                    errorHandler(error)
                })
        } else {
            store.dispatch('outdoors/outdoorsSettings/getLocalizationScreenSizes')
                .then(() => {
                    next(vm => {
                        vm.action = 'createLocalization'
                        vm.pageTitle = 'Nowa lokalizacja'
                    })
                })
                .catch(error => {
                    next(error)
                    errorHandler(error)
                })
        }
    },
    data() {
        return {
            google: null,
            mapDialog: false,
            pageTitle: null,
            localization: {
                number: null,
                customerId: null,
                name: null,
                city: null,
                street: null,
                postCode: null,
                latitude: null,
                longitude: null,
                outdoorLocalizationTeamIds: [],
                outdoorLocalizationScreens: []
            },
            savedLatitude: null,
            savedLongitude: null,
            currentOutdoorsLocalizationScreen: {},
            customersSearch: null,
            customersSearchLoading: false,
            customers: [],
            outdoorLocalizationTeamsSearch: null,
            outdoorLocalizationTeamsSearchLoading: false,
            outdoorLocalizationTeams: [],
            actionLoading: false,
            action: null,
            outdoorsLocalizationScreenDialog: false,
            confirmRemoveLocalizationScreenDialog: false,
            apiKey:  appConfig.outdoors.map.apiKey,
            windowHeight: 0,
            headers: [
                {
                    text: 'Numer ekranu',
                    value: 'ordinalNumber',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Grupa',
                    value: 'localizationScreenGroup',
                    align: 'center',
                    sortable: false,
                    width: 150
                },
                {
                    text: 'Wymiar',
                    value: 'localizationScreenSize',
                    align: 'center',
                    sortable: false,
                    width: 250
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    align: 'center',
                    sortable: false,
                    width: 100
                },
            ]
        }
    },
    computed: {
        hasScreens() {
            return this.localization.outdoorLocalizationScreens.length > 0
        },
        isCustomerSelected() {
            return !isEmpty(this.localization.customer)
        },
        customerIdErrors() {
            const errors = []

            if (!this.$v.localization.customerId.$dirty) return errors
            if (!this.$v.localization.customerId.required)
                errors.push('Klient jest wymagany.')

            return errors
        },
        numberErrors() {
            const errors = []

            if (!this.$v.localization.number.$dirty) return errors
            if (!this.$v.localization.number.maxLength)
                errors.push('Number może zawierać maksymalnie 8 znaków.')
            if (!this.$v.localization.number.required)
                errors.push('Numer jest wymagany.')

            return errors
        },
        cityErrors() {
            const errors = []

            if (!this.$v.localization.city.$dirty) return errors
            if (!this.$v.localization.city.required)
                errors.push('Miasto jest wymagane.')

            return errors
        },
        streetErrors() {
            const errors = []

            if (!this.$v.localization.street.$dirty) return errors
            if (!this.$v.localization.street.required)
                errors.push('Ulica jest wymagana.')

            return errors
        },
        postCodeErrors() {
            const errors = []

            if (!this.$v.localization.postCode.$dirty) return errors
            if (!this.$v.localization.postCode.required)
                errors.push('Kod pocztowy jest wymagany.')

            return errors
        },
    },
    validations() {
        return {
            localization: {
                customerId: {
                    required
                },
                number: {
                    maxLength: maxLength(8),
                    required
                },
                city: {
                    required
                },
                street: {
                    required
                },
                postCode: {
                    required
                }
            }
        }
    },
    watch: {
        customersSearch(value = null) {
            if (value === null) return

            this.customersSearchLoading = true

            clearTimeout(searchTimer)

            searchTimer = setTimeout(() => {
                if (value) {
                    this.searchCustomers(value)
                } else {
                    this.customersSearchLoading = false
                    this.customers = []
                }
            }, 500)
        },
        outdoorLocalizationTeamsSearch(value = null) {
            if (value === null) return

            this.outdoorLocalizationTeamsSearchLoading = true

            clearTimeout(searchTimer)

            searchTimer = setTimeout(() => {
                if (value) {
                    this.searchOutdoorLocalizationTeams(value)
                } else {
                    this.outdoorLocalizationTeamsSearchLoading = false
                    this.outdoorLocalizationTeams = []
                }
            }, 500)
        },
    },
    methods: {
        changeLocalizationName(value) {
            this.localization.name = this.parseEmptyStringToNull(value)
        },
        changeLocalizationLatitude(value) {
            const parsedValue = this.parseEmptyStringToNull(value)

            this.localization.latitude = parsedValue ? parseFloat(parsedValue) : null
        },
        changeLocalizationLongitude(value) {
            const parsedValue = this.parseEmptyStringToNull(value)

            this.localization.longitude = parsedValue ? parseFloat(parsedValue) : null
        },
        indexedLocalizationScreens() {
            this.localization.outdoorLocalizationScreens.forEach(item => {
                delete item.index
            })
            this.localization.outdoorLocalizationScreens = this.localization.outdoorLocalizationScreens.map((item, index) => ({
                index,
                ...item
            }))
        },
        clearOutdoorLocalizationTeamsSearch() {
            this.outdoorLocalizationTeamsSearch = null
        },
        removeOutdoorLocalizationTeam(outdoorLocalizationTeam) {
            const index = this.localization.outdoorLocalizationTeamIds.findIndex(id => id === outdoorLocalizationTeam.id)

            this.localization.outdoorLocalizationTeamIds.splice(index, 1)
        },
        showMapDialog() {
            this.windowHeight = window.innerHeight - 250

            googleMapsApiLoader({
                apiKey: appConfig.outdoors.map.apiKey,
                language: 'pl',
                region: 'PL',
                mapId: appConfig.outdoors.map.mapId
            })
                .then(google => {
                    this.google = google
                    this.mapDialog = true
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        closeMapDialog() {
            this.mapDialog = false
            this.google = null
        },
        saveCoordinates(latitude, longitude) {
            if (latitude && longitude) {
                this.localization.latitude = latitude
                this.localization.longitude = longitude
                this.savedLatitude = latitude
                this.savedLongitude = longitude
            }
        },
        showConfirmRemoveLocalizationScreenDialog(localizationScreenIndex) {
            const index = this.localization.outdoorLocalizationScreens.findIndex(item => item.index === localizationScreenIndex)

            this.currentOutdoorsLocalizationScreen = this.localization.outdoorLocalizationScreens[index]
            this.confirmRemoveLocalizationScreenDialog = true
        },
        removeLocalizationScreen(outdoorsLocalizationScreen) {
            const screenIndex = this.localization.outdoorLocalizationScreens.findIndex(item => item.index === outdoorsLocalizationScreen.index)

            this.localization.outdoorLocalizationScreens.splice(screenIndex, 1)

            this.indexedLocalizationScreens()
            this.closeConfirmRemoveLocalizationScreenDialog()
        },
        closeConfirmRemoveLocalizationScreenDialog() {
            this.confirmRemoveLocalizationScreenDialog = false

            setTimeout(() => {
                this.currentOutdoorsLocalizationScreen = {}
            }, 500)
        },
        async getOutdoorsLocalizationScreenGroups() {
            return await this.$store.dispatch('outdoors/outdoorsSettings/getLocalizationScreenGroups', {
                paginate: '',
                query: `?customerId=${this.localization.customer.id}`
            })
                .catch(error => {
                    errorHandler(error)
                })
        },
        showCreateOutdoorsLocalizationScreenDialog() {
            this.getOutdoorsLocalizationScreenGroups().then(() => {
                this.outdoorsLocalizationScreenDialog = true
            })
        },
        showEditLocalizationScreenDialog(localizationScreenIndex) {
            this.getOutdoorsLocalizationScreenGroups().then(() => {
                const index = this.localization.outdoorLocalizationScreens.findIndex(item => item.index === localizationScreenIndex)

                this.currentOutdoorsLocalizationScreen = this.localization.outdoorLocalizationScreens[index]
                this.outdoorsLocalizationScreenDialog = true
            })
        },
        saveLocalizationScreen(screenData) {
            const index = this.localization.outdoorLocalizationScreens.findIndex(item => item.index === screenData.index)

            if (index >= 0) {
                this.localization.outdoorLocalizationScreens.splice(index, 1, screenData)
            } else {
                this.localization.outdoorLocalizationScreens.push(screenData)
                this.indexedLocalizationScreens()
            }
        },
        closeOutdoorsLocalizationScreenDialog() {
            this.outdoorsLocalizationScreenDialog = false

            setTimeout(() => {
                this.currentOutdoorsLocalizationScreen = {}
            }, 500)
        },
        searchCustomers(query = '') {
            addSentryBreadcrumb('ui.action', 'Wyszukiwanie klienta')
            
            this.$store.dispatch('customers/getCustomers', {
                paginate: '?limit=20',
                query: `&hasOutdoorLocalizations=true&name=${query}`
            })
                .then(response => {
                    this.customers = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.customersSearchLoading = false
                })
        },
        searchOutdoorLocalizationTeams(query = '') {
            addSentryBreadcrumb('ui.action', 'Wyszukiwanie ekip')
            
            this.$store.dispatch('outdoors/outdoorsSettings/getTeams', {
                paginate: '?limit=20',
                query: `&name=${query}`
            })
                .then(response => {
                    this.outdoorLocalizationTeams = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.outdoorLocalizationTeamsSearchLoading = false
                })
        },
        saveLocalization() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.actionLoading = true
            this.localization.customerId = this.localization.customer.id
            this.$store.dispatch(`outdoors/outdoorsSettings/${this.action}`, this.localization)
                .then(() => {
                    this.onClose()
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                })
        },
        onClose() {
            this.$router.push({ name: 'outdoorsSettingsOutdoorsLocalizations' })
                .catch(error => {
                    errorHandler(error)
                })
        },
    }
}
</script>